/* eslint-disable no-param-reassign */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import AquariumItem from './AquariumItem';
import BubbleMaker from './BubbleMaker';

export default class AquariumItemManager extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.draggingItems = [];
    this.activeItems = [];
    this.itemTrash = [];
    this.curDrag = {};

    this.deleteRects = [];
  }

  /**
   * @param {Phaser.Input.Pointer} pointer
   * @param {AquariumItem | BubbleMaker} item 
   */
  onPickupMenuItem (pointer, item) {
    const pt = ABCyaPhaser.GameObjects.getScreenPosition(item);
    item.setPosition(pt.x, pt.y);
    item.offsetX = item.x - pointer.x;
    item.offsetY = item.y - pointer.y;
    if (!this.scene.game.device.os.desktop) item.offsetY -= 26;
    if (item.parentContainer && item.parentContainer !== this) {
      item.parentContainer.remove(item);
    }
    this.add(item);
    ABCyaPhaser.Tweens.addTween(item, 120, { scale: 1 }, Phaser.Math.Easing.Quadratic.Out);
    this.draggingItems.push(item);
  }

  /**
   * 
   * @param {Phaser.Input.Pointer} pointer 
   * @param {AquariumItem | BubbleMaker} item 
   */
  onMoveMenuItem (pointer, item) {
    const newx = pointer.x + item.offsetX;
    const newy = pointer.y + item.offsetY;

    if (item.itemType === 'Fish') {
      if (newx < item.x - 1) {
        item.turnDir(-1);
      }
      else if (newx > item.x + 1) {
        item.turnDir(1);
      }
      item.curPos.x = newx;
      item.curPos.y = newy;
    }
    item.x = newx;
    item.y = newy;
  }

  /**
   * 
   * @param {AquariumItem | BubbleMaker} item 
   */
  onReleaseMenuItem (item) {
    const index = this.draggingItems.indexOf(item);
    if (index === -1) return; // this item wasn't clicked on, but the pointer was released on it, don't do anything
    this.draggingItems.splice(index,1);
    item.removeAllListeners();
    const len = this.deleteRects.length;

    const itemHitRect = item.getHitRect();
    let isHit = false;
    for (let i = 0; i < len; i++) {
      if (Phaser.Geom.Rectangle.Overlaps(itemHitRect, this.deleteRects[i])) {
        isHit = true;
      }
    }
    if (!isHit) {
      item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, pointer => this.onPickupItem(pointer, item));
      item.on(Phaser.Input.Events.GAMEOBJECT_DRAG, pointer => this.onMoveItem(pointer, item));
      item.on(Phaser.Input.Events.GAMEOBJECT_DRAG_END, () => this.onReleaseItem(item));
      if (item.itemType === 'Fish') {
        item.scaleX = item.direction;
        item.scaleY = 1;
        item.initPositionValues(item.x, item.y, null);
        if (!item.firstDrop) {
          item.firstDrop = true;
          item.initializeRoam();
        }
        else {
          item.initializeHover();
        }
        this.activeItems.push(item);
      }
      else if (item.itemType === 'BubbleMaker') {
        this.activeItems.push(item);
      }
    }
    else {
      this.removeItem(item);
    }
  }

  /**
   * @param {Phaser.Input.Pointer} pointer
   * @param {AquariumItem | BubbleMaker} item 
   */
  onPickupItem (pointer, item) {
    item.swimState = null;
    if (item.parentContainer && item.parentContainer !== this) {
      item.parentContainer.remove(item);
    }
    this.add(item);
    item.offsetX = item.x - pointer.x;
    item.offsetY = item.y - pointer.y;
    const index = this.activeItems.indexOf(item);
    if (item.itemType === 'Fish') {
      this.activeItems.splice(index,1);
      this.draggingItems.push(item);
    }
  }

  /**
   * @param {Phaser.Input.Pointer} pointer
   * @param {AquariumItem | BubbleMaker} item 
   */
  onMoveItem (pointer, item) {
    const newx = pointer.x + item.offsetX;
    const newy = pointer.y + item.offsetY;
    if (item.itemType === 'Fish') {
      if (newx < item.x - 1) {
        item.turnDir(-1);
      }
      else if (newx > item.x + 1) {
        item.turnDir(1);
      }
      item.curPos.x = newx;
      item.curPos.y = newy;
    }
    this.curDrag = item;
    item.x = newx;
    item.y = newy;
  }

  /**
   * 
   * @param {AquariumItem | BubbleMaker} item 
   */
  onReleaseItem (item) {
    const len = this.deleteRects.length;
    const itemHitRect = item.getHitRect();
    let isHit = false;
    for (let i = 0; i < len; i++) {
      if (Phaser.Geom.Rectangle.Overlaps(itemHitRect, this.deleteRects[i])) {
        isHit = true;
      }
    }
    if (isHit) {
      // this.removeItem(item);
      if (item === this.curDrag) {
        this.removeItem(this.curDrag);
      }
    }
    else {
      if (item.itemType === 'Fish') {
        const index = this.draggingItems.indexOf(item);
        if (index === -1) return;
        this.draggingItems.splice(index,1);
        item.initPositionValues(item.x, item.y, null);
        this.activeItems.push(item);
        item.initializeHover();
      }
    }
  }

  /**
   * 
   * @param {AquariumItem | BubbleMaker} item 
   */
  removeItem (item) {
    item.removeAllListeners();
    this.itemTrash.push(item);

    if (item.itemType === 'Fish') {
      item.blinkWaiter = null;
      item.on(AquariumItem.ARRIVED_DESTINATION, () => this.destroyItem(item));
      item.initializeInOut(Phaser.Math.Between(10,400),Phaser.Math.Between(10,300),0);
    }
    else if (item.itemType === 'BubbleMaker') {
      const index = this.activeItems.indexOf(item);
      if (index > -1) this.activeItems.splice(index,1);

      item.prepareForRemove();
      item.on('BUBBLES_DONE',() => this.destroyItem(item));
    }
  }

  /**
   * 
   * @param {AquariumItem | BubbleMaker} item 
   */
  destroyItem (item) {
    const index = this.itemTrash.indexOf(item);
    item.destroy();
    this.itemTrash.splice(index, 1);
  }

  doRoaming () {
    const len = this.activeItems.length - 1;
    for (let i = len; i >= 0; i--) {
      if (this.activeItems[i].itemType === 'Fish') {
        this.activeItems[i].initializeRoam();
      }
    }
  }

  setDeleteRects (value) {
    this.deleteRects = value;
  }

  tick (delta) {
    let len = this.activeItems.length - 1;
    for (let i = len; i >= 0; i--) {
      this.activeItems[i].tick(delta);
    }
    len = this.itemTrash.length - 1;
    for (let i = len; i >= 0; i--) {
      this.itemTrash[i].tick(delta);
    }
  }
}